const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/staff-schedule.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/staff-schedule')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ──────────────────────────────────────────────────────────────────

interface Member {
  id: string;
  displayName: string | null;
  inviteEmail: string;
  status: string;
  roleName: string;
}
interface ScheduleSlot {
  id: string;
  memberId: string;
  memberName: string;
  locationId: string | null;
  dayOfWeek: number;
  specificDate: string;
  startTime: string;
  endTime: string;
  type: 'shift' | 'availability' | 'time-off';
  timeOffType: string;
  seriesId: string | null;
  notes: string;
}
type FormType = 'shift' | 'availability' | 'time-off';
type TimeOffSubType = 'vacation' | 'sick' | 'personal' | 'unavailable' | 'holiday';

// ─── Constants ──────────────────────────────────────────────────────────────

// 6am to 9pm

// Day/time-off labels are produced via t() inside the component so they respect language changes.

// ─── Helpers ────────────────────────────────────────────────────────────────

// ─── Component ──────────────────────────────────────────────────────────────

// ─── Modal overlay ────────────────────────────────────────────────────────